/* eslint-disable max-lines */
import { CFMixins, CFTokens, getAnimatedHeight, } from '@connectrn/ds-ui-base';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
const AnimatedHeightElements = {
    Content: styled.div `
    ${CFMixins.animatedHeight.contentWrapper()}
  `,
    NextContent: styled.div `
    ${CFMixins.animatedHeight.nextContentWrapper()}
  `,
};
export const useCFAnimatedHeight = (initialOptions) => {
    const { ANIMATED_HEIGHT_DEFAULT_OPTIONS: defaultOptions } = CFTokens;
    const nextContentRef = useRef(null);
    //
    // State
    //
    const [actualHeight, setActualHeight] = useState(0);
    const [displayedContent, setDisplayedContent] = useState(null);
    const [nextContent, setNextContent] = useState(null);
    const [options, setOptions] = useState(Object.assign(Object.assign({}, defaultOptions), initialOptions));
    //
    // Animated values
    //
    const [heightAnimated, setHeightAnimated] = useState(0);
    const [contentOpacityAnimated, setOpacityAnimated] = useState(0);
    //
    // Animation worklets
    //
    const animatedHeight = {
        height: heightAnimated,
        transition: `height, ease-in, ${options.duration}ms`,
    };
    const animatedOpacity = {
        opacity: contentOpacityAnimated,
        transition: `opacity, linear, ${options.duration * 0.4}ms ${contentOpacityAnimated === 1 ? options.duration * 0.4 : 0}ms`,
    };
    //
    // Effects
    //
    useEffect(() => {
        var _a;
        setActualHeight(Math.round(((_a = nextContentRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || 0));
    }, [nextContent]);
    useEffect(() => {
        const { duration } = options;
        // Fade out current content
        setOpacityAnimated(0);
        // Get the new height
        setHeightAnimated(getAnimatedHeight(actualHeight, options));
        // Set timer to delay adding new content
        setTimeout(() => {
            // Set new content
            setDisplayedContent(nextContent);
            // Fade in new content
            if (options.height !== 0)
                setOpacityAnimated(1);
        }, duration);
        // if actual height
    }, [actualHeight]);
    useEffect(() => {
        const { content } = options;
        // if new content is provided, set it and defer further actions to actual height effect
        if (content !== nextContent) {
            setNextContent(content);
            return;
        }
        // otherwise, if height, max height, or min height changed, transition to the new setting
        const newHeight = getAnimatedHeight(actualHeight, options);
        // Fade content in or out if we're moving to or from a height of 0.
        if (heightAnimated === 0 && newHeight > 0) {
            setOpacityAnimated(1);
        }
        else if (heightAnimated > 0 && newHeight === 0) {
            setOpacityAnimated(0);
        }
        // Finally set new height
        setHeightAnimated(newHeight);
        return;
    }, [options]);
    return Object.assign({ actualHeight, animatedContent: () => {
            const { Content, NextContent } = AnimatedHeightElements;
            return (React.createElement(React.Fragment, null,
                React.createElement(NextContent, { "aria-hidden": true, ref: nextContentRef }, nextContent),
                React.createElement(Content, { style: Object.assign(Object.assign({}, animatedHeight), animatedOpacity) }, displayedContent)));
        }, change: (newOptions) => {
            setOptions(Object.assign(Object.assign({}, options), newOptions));
        } }, options);
};
